import { render, staticRenderFns } from "./ReSearchObjects.vue?vue&type=template&id=4c9fb0a2&scoped=true"
import script from "./ReSearchObjects.vue?vue&type=script&lang=js"
export * from "./ReSearchObjects.vue?vue&type=script&lang=js"
import style0 from "./ReSearchObjects.vue?vue&type=style&index=0&id=4c9fb0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9fb0a2",
  null
  
)

export default component.exports